import { FC, ReactNode } from 'react'
import Logo from 'builder/components/Logo'
import Icon from 'builder/components/Icon'
import {
  Main,
  Container,
  Navbar,
  SkipButton,
  StepsWrapper,
  Title,
  HeaderButtonsContainer,
  CloseButton,
} from './styles'
import TemplateGuestSteps from './TemplateGuestSteps'
import { useMainAppContext } from './context/TemplatesGuestContext'
import { useI18n } from 'builder/hooks/useI18n'

type LayoutProps = {
  regionPrefix: string
  skipTemplatesVariant?: 'v1' | 'v2'
  handleSkipButton: () => void
  handleExitButton?: () => void
  children: ReactNode
  loading?: boolean
  userCategoryPageSelection?: boolean
}

const TemplatesLayout: FC<LayoutProps> = ({
  children,
  regionPrefix,
  handleSkipButton,
  handleExitButton,
  userCategoryPageSelection,
  loading = false,
  skipTemplatesVariant,
  ...rest
}) => {
  const { i18n } = useI18n()
  const { currentStepName } = useMainAppContext()
  const homepageUrl = `/${regionPrefix}`

  return (
    <Container {...rest}>
      <Navbar>
        <a aria-label="Logo" href={homepageUrl}>
          <Logo />
        </a>

        {currentStepName !== 'templates' && (
          <StepsWrapper>
            <TemplateGuestSteps userCategoryPageSelection={userCategoryPageSelection} />
          </StepsWrapper>
        )}

        {currentStepName === 'templates' && (
          <>
            <Title>{i18n.t('builder.templates.choose_template')}</Title>
            <HeaderButtonsContainer>
              {skipTemplatesVariant === 'v1' && (
                <CloseButton aria-label="Close" href={homepageUrl} onClick={handleExitButton}>
                  <Icon.CloseLarge />
                </CloseButton>
              )}
              {skipTemplatesVariant !== 'v1' && (
                <SkipButton onClick={handleSkipButton} isLoading={loading} isDisabled={loading}>
                  {i18n.t('builder.sign_in.methods.skip')}
                </SkipButton>
              )}
            </HeaderButtonsContainer>
          </>
        )}
      </Navbar>
      <Main>{children}</Main>
    </Container>
  )
}

export default TemplatesLayout
